import { create } from "zustand";
import type { Prompt, PromptType } from "../../types";
import { api } from "@/api/client";

interface PromptsStore {
  prompts: Prompt[];
  loading: boolean;
  error: string | null;
  fetch: () => Promise<void>;
  add: (name: string, template: string, dimensions: string[], type?: PromptType, category?: string) => Promise<void>;
  update: (id: number, fields: { name?: string; template?: string; dimensions?: string[]; type?: PromptType; category?: string }) => Promise<void>;
  remove: (id: number) => Promise<"deleted" | "archived">;
}

export const usePromptsStore = create<PromptsStore>((set, get) => ({
  prompts: [],
  loading: false,
  error: null,

  fetch: async () => {
    set({ loading: true });
    try {
      const prompts = await api.prompts.list();
      set({ prompts, loading: false, error: null });
    } catch (err: any) {
      set({ loading: false, error: err?.message || "Failed to load prompts" });
    }
  },

  add: async (name, template, dimensions, type, category) => {
    await api.prompts.create(name, template, dimensions, type, category);
    await get().fetch();
  },

  update: async (id, fields) => {
    await api.prompts.update(id, fields);
    await get().fetch();
  },

  remove: async (id) => {
    const response = await api.prompts.delete(id);
    await get().fetch();

    return response.mode;
  },
}));
